import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DxPivotGridComponent} from 'devextreme-angular';
import moment from 'moment';

export class ReportRequest {
  from: Date;
  to: Date;

  constructor() {
    this.from = new Date();
    this.to = new Date();
  }
}

@Component({
  selector: 'app-reports-toolbar',
  templateUrl: './reports-toolbar.component.html',
  styleUrls: ['./reports-toolbar.component.scss']
})
export class ReportsToolbarComponent implements OnInit {

  @Input()
  pivotGrid: DxPivotGridComponent;

  @Output()
  generate = new EventEmitter<ReportRequest>();

  generateButtonOptions: any;
  filterChooserButtonOptions: any;
  exportButtonOptions: any;
  request = new ReportRequest();


  dateFilters: any = [
    {value: 0, label: 'Période Personnalisée'},
    {value: 1, label: 'Dernière heure'},
    {value: 2, label: 'Aujourd\'hui'},
    {value: 3, label: 'Hier'},
    {value: 4, label: 'Avant hier'},
    {value: 5, label: 'Il y a 3 jours'},
    {value: 6, label: 'Cette Semaine'},
    {value: 7, label: 'La Semaine Dernière'},
    {value: 8, label: 'Ce Mois'},
    {value: 9, label: 'Le Mois Dernier'},
  ];

  constructor() {

    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);

    this.generateButtonOptions = {
      icon: 'repeat',
      text: 'Génerer',
      onClick: () => {
        this.generate.emit(this.request);
      }
    };

    this.filterChooserButtonOptions = {
      icon: 'filter',
      text: 'Filtrer',
      onClick: () => {
        this.pivotGrid.instance.getFieldChooserPopup().show();
      }
    };

    this.exportButtonOptions = {
      icon: 'xlsxfile',
      text: 'Exporter',
      onClick: () => {
        this.pivotGrid.instance.exportToExcel();
      }
    };

  }

  ngOnInit(): void {
  }

  dateFilterChanged(e) {
    switch (e.value) {
      case 1:
        this.request.from = moment().subtract(1, 'hours').toDate();
        this.request.to = moment().toDate();
        break;
      case 2:
        this.request.from = moment().startOf('day').toDate();
        this.request.to = moment().endOf('day').toDate();
        break;
      case 3:
        this.request.from = moment().subtract(1, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(1, 'days').endOf('day').toDate();
        break;
      case 4:
        this.request.from = moment().subtract(2, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(2, 'days').endOf('day').toDate();
        break;
      case 5:
        this.request.from = moment().subtract(3, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(3, 'days').endOf('day').toDate();
        break;
      case 6:
        this.request.from = moment().startOf('week').toDate();
        this.request.to = moment().toDate();
        break;
      case 7:
        this.request.from = moment().subtract(1, 'weeks').startOf('week').toDate();
        this.request.to = moment().subtract(1, 'weeks').endOf('week').toDate();
        break;
      case 8:
        this.request.from = moment().startOf('month').toDate();
        this.request.to = moment().toDate();
        break;
      case 9:
        this.request.from = moment().subtract(1, 'months').startOf('month').toDate();
        this.request.to = moment().subtract(1, 'months').endOf('month').toDate();
        break;
    }
  }

}
